<div class="checker" [class.disabled]="DisableCheckBox">
    <span [class.checked]="value">
        <input [attr.id]="CheckBoxId" type="checkbox" [(ngModel)]="value"  [attr.name]="CheckBoxName" [attr.checked]="value" [disabled]="DisableCheckBox">
    </span>
</div>
<!-- <b>{{CheckBoxText}}</b> -->
<label [attr.for]="CheckBoxId"><b>{{CheckBoxText}}</b></label>